<template>
    <div class="partnership_plan">
        <div class="header">
            <div class="header_box">
                <div class="header_left">
                    <img class="header_left_title" src="./images/partnership_plan_title.png" alt="版权家合伙人计划">
                    <img class="header_left_subtitle" src="./images/partnership_plan_subtitle.png" alt="在版权家平台 成就大家梦想">
                </div>
                <div class="header_right">
                    <h1 class="header_right_title">企业合伙人加盟</h1>

                    <Form :model="partnerJoiningFrom"
                          :rules="rulePartnerJoining"
                          :hide-required-mark="true"
                          class="partner_joining_from"
                          ref="formPartnerJoining">

                        <FormItem class="partner_joining_item" prop="name">
                            <Input v-model.trim="partnerJoiningFrom.name"
                                   maxlength="20"
                                   class="register_search_model_input"
                                   placeholder="请输入企业名称"/>
                        </FormItem>

                        <FormItem class="partner_joining_item" prop="phone">
                            <Input v-model="partnerJoiningFrom.phone" class="register_search_model_input"
                                   maxlength="11"
                                   placeholder="请输入联系电话"/>
                        </FormItem>

                        <FormItem class="partner_joining_item" prop="remarks">
                            <Input v-model.trim="partnerJoiningFrom.remarks"
                                   maxlength="40"
                                   class="register_search_model_input"
                                   placeholder="请输入备注信息"/>
                        </FormItem>
                    </Form>

                    <button @click="partnerJoiningSubmit" :disabled="partnerJoiningDisabled" class="header_right_submit">加盟版权家</button>
                </div>
            </div>
        </div>

        <div class="partnership_plan_desc">
            <div class="container">
                <ul class="partnership_plan_desc_main">
                    <li class="partnership_plan_desc_main_item">
                        <img class="partnership_plan_desc_main_item_img" src="./images/partnership_plan_desc_01.png"
                             alt="一站式版权服务">
                        <div class="partnership_plan_desc_main_item_title">一站式版权服务</div>
                        <p class="partnership_plan_desc_main_item_msg">
                            提供版权登记、版权存证、盗版监测、侵权取证、法律维权、版权交易等综合版权服务，“一站式”解决用户的所有版权问题</p>
                    </li>
                    <li class="partnership_plan_desc_main_item">
                        <img class="partnership_plan_desc_main_item_img" src="./images/partnership_plan_desc_02.png"
                             alt="便捷的推广方式">
                        <div class="partnership_plan_desc_main_item_title">便捷的推广方式</div>
                        <p class="partnership_plan_desc_main_item_msg">您将获得分配的唯一ID，可通过朋友圈、微信、网站等各种方式让使用该ID的人成为您的推广用户</p>
                    </li>
                    <li class="partnership_plan_desc_main_item">
                        <img class="partnership_plan_desc_main_item_img" src="./images/partnership_plan_desc_03.png"
                             alt="轻松好赚钱">
                        <div class="partnership_plan_desc_main_item_title">轻松好赚钱</div>
                        <p class="partnership_plan_desc_main_item_msg">成为代理商，享最低成本价，获高额利润差；超额完成任务，享受额外奖励</p>
                    </li>
                </ul>
                <div @click="openChats" style="margin-top: 40px" class="threeSyndromesActivity_btn arrow">开始赚钱</div>
            </div>
        </div>

        <!--    版权家提供的服务    -->
        <div class="providing_services">
            <div style="margin-bottom: -11px" class="title_big">版权家提供的服务</div>
            <firsecond backgroundColor="#F6F9FF"/>
        </div>

        <!--    您无需担忧    -->
        <div class="no_worries">
            <div class="container">
                <div class="title_big">您无需担忧</div>
                <ul class="no_worries_group">
                    <li class="no_worries_item">
                        <img class="no_worries_item_img" src="./images/no_worries_01.png" alt="即时收益">
                        <div class="no_worries_item_name">即时收益</div>
                        <div class="no_worries_item_content">
                            <p>及时结算，T+3现金到账</p>
                            <p>更大的盈利空间</p>
                        </div>
                    </li>
                    <li class="no_worries_item">
                        <img class="no_worries_item_img" src="./images/no_worries_02.png" alt="长久利益">
                        <div class="no_worries_item_name">长久利益</div>
                        <div class="no_worries_item_content">
                            <p>分享链接长久有效，一次邀请永久绑定</p>
                        </div>
                    </li>
                    <li class="no_worries_item">
                        <img class="no_worries_item_img" src="./images/no_worries_03.png" alt="合作期限">
                        <div class="no_worries_item_name">合作期限</div>
                        <div class="no_worries_item_content">
                            <p>版权家合伙人计划，一次合作，永久亲密合作</p>
                        </div>
                    </li>
                    <li class="no_worries_item">
                        <img class="no_worries_item_img" src="./images/no_worries_04.png" alt="安全">
                        <div class="no_worries_item_name">安全</div>
                        <div class="no_worries_item_content">
                            <p>区块链技术功底，保障产品安全，信息安全</p>
                        </div>
                    </li>
                    <li class="no_worries_item">
                        <img class="no_worries_item_img" src="./images/no_worries_05.png" alt="专业保障">
                        <div class="no_worries_item_name">专业保障</div>
                        <div class="no_worries_item_content">
                            <p>专业咨询支持&nbsp;&nbsp;专业交付保障 专业知识培训</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!--    合伙赚钱 流程简单    -->
        <div class="partnership_process">
            <div class="title_big">合伙赚钱 流程简单</div>
            <flowChart class="partnership_process_main" :data="partnershipProcessData" boxWidth="245px" boxHeight="100px" />
            <div @click="openChats" class="threeSyndromesActivity_btn arrow partner">成为合伙人</div>

        </div>

        <!--    他们都在用版权家    -->
        <div class="users">
            <div class="title_big">他们都在用版权家</div>
            <div class="users_subtitle">加入版权家合伙人</div>
            <firsix :isFirstPage="false" />
            <div @click="openChats" class="threeSyndromesActivity_btn arrow partner">成为合伙人</div>
        </div>
    </div>
</template>

<script>
    import firsecond from '@/views/vipClip/firstPage/components/firsecond/firsecond.vue';
    import flowChart from '@/views/main-components/flow-chart.vue';
    import firsix from '@/views/vipClip/firstPage/components/firsix/firsix.vue'
    import {_insertCustom} from "../../../api/register";
    import {leavemessage} from '@/api/staticPage'


    export default {
        name: "partnershipPlan",
        components: {
            firsecond,
            flowChart,
            firsix
        },
        metaInfo: {
            title: '版权家合作人计划|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '监测详情,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        data() {
            return {
                partnerJoiningFrom: {
                    name:'',
                    phone:'',
                    remarks:''
                }, //企业合伙人加盟表单字段
                rulePartnerJoining: {
                    name: [
                        {required: true, message: '企业名称不能为空', trigger: 'blur'},
                    ],
                    phone: [
                        {required: true, message: '联系电话不能为空', trigger: 'blur'},
                        {pattern: /^1[3456789]\d{9}$/, message: "联系电话格式不正确", trigger: "blur"}
                    ]
                }, //企业合伙人加盟验证规则
                partnerJoiningDisabled:false, //企业合伙人加盟提交按钮禁止事件
                partnershipProcessData: [
                    {
                        icon: require('@/views/vipClip/partnershipPlan/images/partnership_process_01.png'),
                        title: '注册版权家用户'
                    },
                    {
                        icon: require('@/views/vipClip/partnershipPlan/images/partnership_process_02.png'),
                        title: '生成专属邀请链接'
                    },
                    {
                        icon: require('@/views/vipClip/partnershipPlan/images/partnership_process_03.png'),
                        title: '使用链接邀请用户'
                    },
                    {
                        icon: require('@/views/vipClip/partnershipPlan/images/partnership_process_04.png'),
                        title: '受邀用户注册并付费'
                    },
                    {icon: require('@/views/vipClip/partnershipPlan/images/partnership_process_05.png'), title: '获取佣金'}
                ], //流程图数据
            }
        },
        created() {

        },
        methods: {
            openChats() {
                if(typeof(_MEIQIA)!='undefined'){
                    _MEIQIA('showPanel');
                }else{
                    console.log("美洽开始初始化"+new Date().getTime());
                    (function(m, ei, q, i, a, j, s) {
                        m[i] = m[i] || function() {
                            (m[i].a = m[i].a || []).push(arguments)
                        };
                        j = ei.createElement(q),
                            s = ei.getElementsByTagName(q)[0];
                        j.async = false;
                        j.charset = 'UTF-8';
                        j.src = '//static.meiqia.com/dist/meiqia.js';
                        s.parentNode.insertBefore(j, s);
                    })(window, document, 'script', '_MEIQIA');
                    _MEIQIA('manualInit');
                    _MEIQIA('entId', '6351b02e1b6975b5b7bb282762244a9f');
                    //隐藏美洽客服按钮
                    _MEIQIA('withoutBtn');
                    // 初始化成功时的回调
                    _MEIQIA('allSet', this.footMeiqiaCallBack);
                    //创建美洽
                    _MEIQIA('init');
                    console.log("美洽初始化结束"+new Date().getTime());
                    _MEIQIA('showPanel');
                }
            },
            partnerJoiningSubmit(){
                this.$refs['formPartnerJoining'].validate((valid) => {
                    if (valid) {
                        this.partnerJoiningDisabled = true;

                        leavemessage(this.partnerJoiningFrom).then(res => {
                            console.log(res);
                            if (res.code == 200) {
                                toast('提交成功');
                                this.partnerJoiningDisabled = false;
                                this.workName = '';
                                this.$refs['formPartnerJoining'].resetFields();
                            } else {
                                this.partnerJoiningDisabled = false;
                                toast(res.message);
                            }
                        })
                    } else {
                        this.partnerJoiningDisabled = false;

                    }
                })
            }
        }
    }
</script>

<style scoped lang="less">
    .container {
        width: 1334px;
        margin: 0 auto;
    }

    .title_big {
        color: #282828;
        font-size: 40px;
        line-height: 1;
        position: relative;
        z-index: 1;
        text-align: center;

        &:after {
            content: '';
            position: absolute;
            width: 64px;
            height: 64px;
            border-radius: 50%;
            left: 50%;
            background: #FFD800;
            z-index: -1;
            top: 50%;
            margin-top: -32px;
            margin-left: -32px;
        }
    }

    .partnership_plan {
        .header {
            width: 100%;
            height: 460px;
            background: url(./images/bg.png) no-repeat left center;
            background-size: cover;

            .header_box {
                width: 1093px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;

                .header_left {
                    padding-top: 116px;

                    .header_left_title {
                        width: 480px;
                        height: 100px;
                        display: block;
                        object-fit: contain;
                    }

                    .header_left_subtitle {
                        width: 483px;
                        height: 72px;
                        display: block;
                        object-fit: contain;
                        margin-top: 17px;
                    }
                }


                .header_right {
                    width: 359px;
                    height: 348px;
                    box-sizing: border-box;
                    background: #fff;
                    border-radius: 8px;
                    margin-top: 56px;
                    padding: 30px 32px 34px;

                    .header_right_title {
                        color: #282828;
                        font-size: 20px;
                        font-weight: 500;
                        line-height: 28px;
                        text-align: center;
                    }


                    .partner_joining_from {
                        padding-top: 28px;

                        .partner_joining_item {
                            /*margin-bottom: 20px;*/

                            /deep/ .ivu-input {
                                height: 40px;
                                padding: 10px 18px;
                                font-size: 14px;
                                border: 1px solid #E5E5E5;

                                &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
                                    color: #A8A8A8;
                                }

                                &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                                    color: #A8A8A8;
                                }

                                &::-moz-placeholder { /* Mozilla Firefox 19+ */
                                    color: #A8A8A8;
                                }

                                &:-ms-input-placeholder { /* Internet Explorer 10-11 */
                                    color: #A8A8A8;
                                }
                            }
                        }
                    }

                    .header_right_submit {
                        width: 100%;
                        height: 40px;
                        line-height: 40px;
                        outline: none;
                        background: #F8D900;
                        color: #282828;
                        font-size: 14px;
                        text-align: center;
                        border: 0;
                        cursor: pointer;
                        margin-top: 8px;
                    }
                }
            }
        }

        .partnership_plan_desc {
            background: #fff;
            padding: 48px 0 72px;

            .partnership_plan_desc_main {
                display: flex;
                justify-content: space-between;
                list-style: none;

                .partnership_plan_desc_main_item {
                    padding: 30px 30px 30px 32px;
                    box-shadow: 0 2px 50px 0 rgba(136, 141, 151, 0.15);
                    margin-right: 50px;
                    width: 411px;
                    box-sizing: border-box;

                    &:last-child {
                        margin-right: 0;
                    }

                    .partnership_plan_desc_main_item_img {
                        display: block;
                        width: 42px;
                        height: 42px;
                        object-fit: cover;
                    }

                    .partnership_plan_desc_main_item_title {
                        color: #282828;
                        font-size: 20px;
                        line-height: 28px;
                        padding-top: 20px;
                    }

                    .partnership_plan_desc_main_item_msg {
                        color: #666666;
                        font-size: 12px;
                        line-height: 24px;
                        padding-top: 10px;
                    }
                }
            }
        }

        .providing_services {
            background: #F6F9FF;
            padding-top: 76px;
            margin-bottom: -4px;
        }

        .no_worries {
            background: #fff;
            padding: 76px 0 66px;

            .no_worries_group {
                display: flex;
                list-style: none;
                padding-top: 52px;
                justify-content: center;

                .no_worries_item {
                    text-align: center;
                    width: 190px;
                    box-sizing: border-box;
                    margin-right: 82px;

                    &:last-child {
                        margin-right: 0;
                    }

                    .no_worries_item_img {
                        display: block;
                        width: 73px;
                        height: 81px;
                        margin: 0 auto;
                    }

                    .no_worries_item_name {
                        color: #000;
                        font-size: 18px;
                        line-height: 25px;
                        font-weight: 500;
                    }

                    .no_worries_item_content {
                        color: #666666;
                        font-size: 14px;
                        line-height: 28px;
                        text-align: center;
                        padding-top: 14px;
                    }
                }
            }
        }

        .partnership_process {
            background: #F6F9FF;
            padding: 76px 0 60px;

            .partnership_process_main{
                padding-top: 52px;
            }
        }

        .users{
            background: #fff;
            padding: 76px 0 73px;

            .users_subtitle{
                color: #282828;
                font-size: 20px;
                text-align: center;
                line-height: 28px;
                padding-top: 20px;
            }
        }
    }

    .threeSyndromesActivity_btn {
        width: 200px;
        height: 50px;
        line-height: 50px;
        background: #FFD800;
        color: #282828;
        font-size: 14px;
        text-align: center;
        align-self: center;
        cursor: pointer;
        margin: 48px auto 0;
        display: block;

        &.arrow {
            &:after {
                content: '';
                background: url(../channelCooperation/images/small_arrow.png) no-repeat right center;
                background-size: 14px 10px;
                padding-left: 23px;
                height: 10px;
            }

            &:hover:after {
                content: '';
                background: url(../channelCooperation/images/small_arrow.png) no-repeat right center;
                background-size: 14px 10px;
                padding-left: 23px;
                height: 10px;
                animation: zy 1s .15s linear infinite;
                display: inline-block;

            }
        }

        &.partner{
            margin-top: 48px;
            width: 258px;
        }

        &.shopping {
            margin: 0 auto;
        }

        &:hover {
            box-shadow: 0 4px 20px 0 rgba(53, 45, 0, 0.08);
        }


    }

    @keyframes zy {

        10% {

            /*transform: rotate(15deg);*/
            transform: translate(2px);

        }

        20% {

            /*transform: rotate(-10deg);*/
            transform: translate(4px);


        }

        30% {

            /*transform: rotate(5deg);*/
            transform: translate(6px);

        }

        40% {

            /*transform: rotate(-5deg);*/
            transform: translate(8px);


        }

        50% {

            /*transform: rotate(0deg);*/
            transform: translate(10px);


        }

        60% {

            /*transform: rotate(0deg);*/
            transform: translate(8px);


        }

        70% {

            /*transform: rotate(0deg);*/
            transform: translate(6px);


        }

        80% {

            /*transform: rotate(0deg);*/
            transform: translate(4px);


        }

        90% {

            /*transform: rotate(0deg);*/
            transform: translate(2px);


        }

        100% {

            /*transform: rotate(0deg);*/
            transform: translate(0);


        }
    }

</style>